import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import {Project} from "@/services/models/project";
import {ProjectCreationResponse} from "@/services/models/projectCreationResponse";
import {isAksBackendTarget} from "@/core/backendTarget";

export const projectApiSlice = createApi({
    reducerPath: 'projectApi',
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getProjectAgent: builder.query<Agent[], { projectId: string }>({
            // AKS has no legacy project 01JFGEEM0KKJ0N40CJWKHT37ZA. Callers use GET /Agents instead.
            async queryFn({projectId}, _api, _extraOptions, baseQuery) {
                if (isAksBackendTarget()) {
                    return {data: []};
                }
                const result = await baseQuery({
                    url: `Project/${projectId}/agents`,
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                if (result.error) {
                    return {error: result.error};
                }
                return {data: result.data as Agent[]};
            },
        }),
        getUserProject: builder.query<Project[], void>({
            query: () => ({
                url: `Project`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
        getProjectById: builder.query<Project, { projectId: string }>({
            query: ({projectId}) => ({
                url: `Project/${projectId}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
        }),
        postNewProject: builder.mutation<ProjectCreationResponse[], {
            name: string;
            description: string,
            theme_id: string
        }>({
            query: ({name, description, theme_id}) => ({
                url: `Project`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: {
                    name,
                    description,
                    theme_id
                },
            }),
        }),
        addUserToProject: builder.mutation<void, { projectId: string; userOid: string }>({
            query: ({ projectId, userOid }) => ({
                url: `Project/${projectId}/users/${userOid}`,
                method: 'POST',
            }),
        }),
        removeUserFromProject: builder.mutation<void, { projectId: string; userOid: string }>({
            query: ({ projectId, userOid }) => ({
                url: `Project/${projectId}/users/${userOid}`,
                method:'DELETE',
            }),
        }),
    }),
})

const {
    useGetProjectAgentQuery,
    useGetUserProjectQuery,
    useGetProjectByIdQuery,
    usePostNewProjectMutation,
    useAddUserToProjectMutation,
    useRemoveUserFromProjectMutation,
} = projectApiSlice
export const projectApiActions = {
    useGetProjectAgentQuery,
    useGetUserProjectQuery,
    useGetProjectByIdQuery,
    usePostNewProjectMutation,
    useAddUserToProjectMutation,
    useRemoveUserFromProjectMutation,
}